import React from 'react';
import { BrowserRouter as Router, Redirect, Link } from 'react-router-dom'
import firebase from 'firebase';
import uuid from 'uuid/v4';
import Loading from '../loading';

import Notifications, {notify} from 'react-notify-toast';
import Generate from '../helpers/generate';


class Create extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			name: '',
			pin: '',
			id : uuid(),
			complete: false,
			loading:false
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
	}

	handleSubmit(event) {

		event.preventDefault();

		if(this.state.pin * 4790 * 4829 !== 53293616640) {
			notify.show('Ask Compassion for the correct PIN to start a game','error')
			return false;
		}

		this.setState({ loading: true });

		let game = {
				id: this.state.id,
				name: this.state.name,
				owner: this.props.user ? this.props.user.uid : false,
				created: new Date().getTime(),
				active: true
			};

		// console.log('creating game', this.state.id, game, this.props.user);
		firebase.database().ref(`games/${this.state.id}/`).set(game)
			.then(response => {
				// console.log('game created', response);
				Generate.profile(this.state.id, this.props.user, true)
				.then(response => {
					// console.log('profile created', response);
					this.setState({ complete: true });
				})
				.catch(error => {
					console.warn('profile creation error', error)
					this.setState({ loading: false });
				})
			})
			.catch(error => {
				console.warn('game creation error', error)
				this.setState({ loading: false });
			})
	}

	render() {

		if (this.state.complete) {
			return <Redirect to={`/game/${this.state.id}/wallet`}/>;
		}

		if (this.state.loading) {
			return <Loading text="Creating Game" />;
		}

		return <section className="create">

		<header>
		<h1>Create a Game</h1>
		<h6>{this.state.id}</h6>
		</header>
		<main>

			<div className="actions ridged">

				<form onSubmit={this.handleSubmit}>
					<label>Full Name</label>
					<input name="name" type="text" placeholder="Group Name" value={this.state.name} onChange={this.handleInputChange}/>

					<label>PIN</label>
					<input name="pin" type="number" placeholder="PIN" value={this.state.pin} onChange={this.handleInputChange}/>

					{this.state.isPinIncorrect && <p className="error">That PIN is invalid</p>}

					<button type="submit" className="button -primary -huge">Create Game</button>

					<div className="cancel">
					<Link to="/">Cancel</Link>
					</div>

				</form>

			</div>
		</main>

		</section>;
	}
}

export default Create



// WEBPACK FOOTER //
// ./src/components/games/create.js